/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, cap: NonNullable<unknown> }} Seo_Price_CappedInputs */

const en_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, and never more than ${i?.cap} for a single request`)
};

const zh_hans1_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}，单次请求最多 ${i?.cap}`)
};

const pt_br2_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, e nunca mais de ${i?.cap} por requisição`)
};

const es_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, y nunca más de ${i?.cap} por una sola solicitud`)
};

const fr_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, et jamais plus de ${i?.cap} pour une seule requête`)
};

const de_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, und nie mehr als ${i?.cap} für eine einzelne Anfrage`)
};

const ru_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, и никогда не больше ${i?.cap} за один запрос`)
};

const it_seo_price_capped = /** @type {(inputs: Seo_Price_CappedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}, e mai più di ${i?.cap} per una singola richiesta`)
};

/**
* | output |
* | --- |
* | "{price}, and never more than {cap} for a single request" |
*
* @param {Seo_Price_CappedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_price_capped = /** @type {((inputs: Seo_Price_CappedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Price_CappedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_price_capped(inputs)
	if (locale === "pt-BR") return pt_br2_seo_price_capped(inputs)
	if (locale === "es") return es_seo_price_capped(inputs)
	if (locale === "fr") return fr_seo_price_capped(inputs)
	if (locale === "de") return de_seo_price_capped(inputs)
	if (locale === "ru") return ru_seo_price_capped(inputs)
	if (locale === "it") return it_seo_price_capped(inputs)
	return en_seo_price_capped(inputs)
});